var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAppmenuBurger(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 22,
    viewBox: "0 0 26 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.0458984 1C0.0458984 1.55228 0.493614 2 1.0459 2L24.9541 2C25.5064 2 25.9541 1.55229 25.9541 1C25.9541 0.447716 25.5064 0 24.9541 0H1.0459C0.493614 0 0.0458984 0.447715 0.0458984 1Z",
    fill: "#68778D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.0458984 11C0.0458984 11.5523 0.493614 12 1.0459 12L24.9541 12C25.5064 12 25.9541 11.5523 25.9541 11C25.9541 10.4477 25.5064 10 24.9541 10L1.0459 10C0.493614 10 0.0458984 10.4477 0.0458984 11Z",
    fill: "#68778D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.0459 22C0.493614 22 0.0458984 21.5523 0.0458984 21C0.0458984 20.4477 0.493614 20 1.0459 20L24.9541 20C25.5064 20 25.9541 20.4477 25.9541 21C25.9541 21.5523 25.5064 22 24.9541 22H1.0459Z",
    fill: "#68778D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppmenuBurger);
export default __webpack_public_path__ + "static/media/app.menu_burger.6f469c1a1c502ed57866a4111a3bc0e7.svg";
export { ForwardRef as ReactComponent };